/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgListH = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M2 15h6v2H2zm7 4h6v2H9zm0-4h6v2H9zM2 9h6V3H2zm2-4h2v2H4zM2 19h6v2H2zm0-8h6v2H2zm14 0h6v2h-6zm0-8v6h6V3zm4 4h-2V5h2zm-4 8h6v2h-6zm-7-4h6v2H9zm7 8h6v2h-6zM9 9h6V3H9zm2-4h2v2h-2z"
      fill="currentcolor"
    />
  </Icon>
);
export { SvgListH as ListH };
